import React, { useEffect,useState } from "react";
import config from "../config";
import axios from "axios";
import { useNavigate,Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import ClipLoader from "react-spinners/ClipLoader"; 
import "./login.css";
import { Header } from "./header";
import { Aside } from "./aside";
import { Footer } from "./footer";

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
function Addproduct() {
  const navigate = useNavigate();
  let   [loadingInProgress, setLoading] = useState(false);

  const [product, setProductname] = useState("");
  const [category, setCategory] = useState([]);
  const [fileProduct, setfileProduct] = useState([]);
  const [categoryId, setCategoryId] = useState("");
  const [categoryName, setCategoryName] = useState("");
  const [description, setDescription] = useState("");
  const [productImage, setProductimage] = useState("");
  
  let handleSubmit =  (e) => {
    e.preventDefault();
    setLoading(true)
    let formData = new FormData(); //formdata object
    formData.append("IMAGE", productImage);
    formData.append("productName", product);
    formData.append("categoryId", categoryId);
    formData.append("categoryName", categoryName);
    formData.append("description", description);
  
      axios.post(`${config.backend_URL}/addProduct`, formData)
        .then( (data) => {
         
          setLoading(false)
          toast(data.data.msz);
          e.target.reset();
        }).catch((err) => {
          console.log("error", err);
        });
  };
  
  const fetchData = () => {
    //e.preventDefault()
    setLoading(true)
    let getloginuser = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        type: 'type',
        
      }),
    };
    return setLoading(true) ,fetch(config.backend_URL + "/getCategory", getloginuser)
    .then((response) => response.json())
    .then((responseJson) => {
      setLoading(false)
      //console.log(responseJson);
          if (responseJson.status) {
           
           
            setCategory(responseJson.data)
            
            
            
            
            
          
        } else {
          toast(responseJson.msz);
          
          //setLoading(false)
          
        }
      
    })
    .catch((error) => {
      toast('It will take some time!');
      setLoading(false)
      //console.error(error);
    });
  
      setLoading(false)
  };
  const onFileChange = async (e) => {
    e.preventDefault();
    

      setProductimage(e.target.files[0]);
   
    
  };
  const handleClick = e => {
    setCategoryId(e.target.value)
    
    setCategoryName(e.target[e.target.selectedIndex].getAttribute('data-value'));

   
  };
  
  useEffect(() => {
    //setLoading(true) ;
    fetchData();
    //fetchData1();
  }, []);
  return (
    <div className="container-scroller">
      {loadingInProgress ? <div className="parentdiv"><div className="loaderclsdiv"><ClipLoader className="loadercls" text-align="center" color={'#000'} loading={loadingInProgress}  size={35} /></div></div>: ""}
      {" "}
      <ToastContainer />
    
      <div class="layout-wrapper layout-content-navbar">
      <div class="layout-container">
    
<Aside/>
<div class="layout-page">


<Header/>
<div class="content-wrapper">


<div class="container-xxl flex-grow-1 container-p-y">
  
  
<div class="row">
<div class="col-md-6">
<h4 class="py-3 mb-4">
<span class="text-muted fw-light">Add Product</span> 
</h4>

</div>
<div class="col-md-6" >

<Link class="dt-button add-new btn btn-primary ms-2 ms-sm-0" tabindex="0" aria-controls="DataTables_Table_0" to={config.front_URL +"/product"}><span><span class="d-none d-sm-inline-block">Back</span></span></Link>
</div>
</div>
<Tabs>
    <TabList>
      <Tab>Product Content</Tab>
      <Tab>Product files</Tab>
    </TabList>

    <TabPanel>
    <form onSubmit={(e) => handleSubmit(e)}>
<div class="row">
<div class="col-md-12">
    <div class="card mb-4">
      {/* <h5 class="card-header">Add Content</h5> */}
      <div class="card-body">
        <div class="row mrgBtm4">
              <div class="col-md-6">
                <div>
          <label for="defaultFormControlInput" class="form-label"><span style={{color:'red'}}>*</span>Category</label>
          <select required class="form-control"  onChange={(e) => handleClick(e) }>
            <option value="">Select Category</option>
            {category.map((category) => {
                            return (
<option value={category._id} data-value={category.name} >{category.name}</option>
                              );
                            })}

          </select>
          {/* <input type="text" required class="form-control" placeholder="Enter Type" onChange={(e) => setType(e.target.value)}/> */}
          
        </div>
        </div>
        <div class="col-md-6">
                <div>
          <label for="defaultFormControlInput" class="form-label"><span style={{color:'red'}}>*</span>Product Name</label>
        
          <input type="text" required class="form-control" placeholder="Enter Product Name" onChange={(e) => setProductname(e.target.value)}/>
          
        </div>
        </div>
             
        </div>
        <div class="row mrgBtm4">
              <div class="col-md-12">
                <div>
          <label for="defaultFormControlInput" class="form-label">Description</label>
          
          <input type="text"  class="form-control" placeholder="Write Here......" onChange={(e) => setDescription(e.target.value)}/>
          
        </div>
        </div>
              
        </div>
        <div class="row mrgBtm4">
              <div class="col-md-3">
                <div>
          <label for="defaultFormControlInput" class="form-label"><span style={{color:'red'}}>*</span>Product Image</label>
          
          <input type="file" required class="form-control"  onChange={(e) => onFileChange(e)}/>
          
        </div>
        </div>
              
        </div>
        
        
      

      
      

        <div class="row mt-3">
          <div class="d-grid gap-2 col-lg-6 mx-auto">
            <button class="btn btn-primary btn-lg waves-effect waves-light" type="submit">Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  
</div>
</form>
    </TabPanel>
    <TabPanel>
    <table id="example23" class="display nowrap table   " cellspacing="0" width="100%">
                                        <thead>
                                           {/*  <tr>
                                                <th></th>
                                              
                                                <th></th>
                                                <th></th>
                                                
                                                <th></th>
                                               
                                            </tr> */}
                                        </thead>
                                        
                                        <tbody>
                                        {fileProduct.map((contentdata) => {
                            return (
                              <>
                                             <tr style={{backgroundColor:' #F0F2F5',width:'100%',marginTop:'10px'}}>
                                               
                                            <td>
                                                    <button class="btn btn-info" ><i class="fa fa-pencil" aria-hidden="true"></i></button>&nbsp;
                                                    <button class="btn btn-primary" ><i class="fa fa-plus" aria-hidden="true"></i></button>&nbsp;
                                                    </td>
                                                    
                                                <td><b>{contentdata.showUser}</b></td>
                                                <td>{contentdata.title}</td>
                                                <td> <button class="btn btn-danger" ><i class="fa fa-trash" aria-hidden="true"></i></button>&nbsp;</td>
                                            </tr>
                                           
                                            
                                             {contentdata.subArray.map((contentdata1) => {
                                              return (
                                                <>
                                                <tr style={{backgroundColor:' #F0F2F5',width:'100%',marginTop:'10px'}}>
                                                <td></td>
                                                <td>
                                                        <button class="btn btn-info" ><i class="fa fa-pencil" aria-hidden="true"></i></button>&nbsp;
                                                        <button class="btn btn-primary" ><i class="fa fa-plus" aria-hidden="true"></i></button>&nbsp;
                                                        </td>
                                                        
                                                    <td><b>{contentdata1.showUser}</b></td>
                                                    <td>{contentdata1.title}</td>
                                                    <td> <button class="btn btn-danger" ><i class="fa fa-trash" aria-hidden="true"></i></button>&nbsp;</td>
                                                </tr>
                                                
                                                              {contentdata1.finalArray.map((contentdata2) => {
                                                                return (
                                                                  <tr style={{backgroundColor:' #F0F2F5',width:'100%',marginTop:'10px'}}>
                                                                  <td></td>
                                                                  <td></td>
                                                                  <td>
                                                                          <button class="btn btn-info" ><i class="fa fa-pencil" aria-hidden="true"></i></button>&nbsp;
                                                                         
                                                                          </td>
                                                                          
                                                                      <td><b>{contentdata2.showUser}</b></td>
                                                                      <td>{contentdata2.title}</td>
                                                                      <td> <button class="btn btn-danger" ><i class="fa fa-trash" aria-hidden="true"></i></button>&nbsp;</td>
                                                                  </tr>
                                                                                   
                                                                                   );         
                                                                                  })}  
                                                                                  </>  
                                                                 );         
                                                                })} 
                                           
                                           
                                           </>
                                            );
                                          })}
                                          
                                        </tbody>
                                    </table>
    </TabPanel>
  </Tabs>

    
            </div>
           
            <Footer/>

  
 
</div>
</div>
           
            
</div>



</div>
</div>
  );
}

export { Addproduct };
